import { useRef, useCallback } from 'react';
import { useSelector } from 'react-redux';
import emptyFunction from 'react-utils/emptyFunction';
import { View } from 'foundations-components/transitional/components/View';
import { SECTION, ELEMENT, LAYOUT } from 'LayoutBuilderUI/lib/DragDropConstants';
// @ts-expect-error no declarations found for module
import { SnapPlaceholder } from 'LayoutBuilderUI/components/dragAndDrop/SnapPlaceholder';
import { DropTarget } from 'react-dnd-compat';
// @ts-expect-error no declarations found for module
import { AsyncSectionAffordances } from 'LayoutBuilderUI/components/AsyncComponents';
// @ts-expect-error no declarations found for module
import MouseEventsHandler from 'LayoutBuilderUI/components/utility/MouseEventsHandler';
// @ts-expect-error no declarations found for module
import { NativeTypes } from 'react-dnd-ipeui-backend';
// @ts-expect-error no declarations found for module
import { dropNewImageElement } from 'LayoutBuilderUI/actions/layoutActions';
import { getMouseOverSectionId } from 'LayoutBuilderUI/selectors/userInterface';
import { DropPosition } from 'EmailEditorUI/redux/actions/types/layoutActions';
// @ts-expect-error no declarations found for module
import { getIsSingleColumnFullWidth } from 'EmailEditorUI/redux/selectors/styleSettingsSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const sectionTarget = {
  drop(props, monitor) {
    const {
      sectionForDrop,
      sectionIndexForDrop,
      dropAtStartOfEmail,
      numSections
    } = props;
    const dropTargetPosition = dropAtStartOfEmail ? DropPosition.BEFORE : DropPosition.AFTER;
    const itemType = monitor.getItemType();
    const dropProps = {
      sectionId: sectionForDrop,
      sectionIndex: sectionIndexForDrop,
      dropPosition: dropTargetPosition,
      type: SECTION,
      forceDropOutsideBoxed: true
    };
    if (!numSections) {
      return {
        newSection: true,
        sectionIndex: 0,
        type: SECTION
      };
    }
    if (itemType === NativeTypes.FILE) {
      const item = monitor.getItem();
      if (item.files && item.files.length) {
        dropNewImageElement(Object.assign({}, dropProps, {
          file: item.files[0]
        }));
      }
      return null;
    }
    // Defines payload for monitor.getDropResult() in endDrag()
    return dropProps;
  },
  canDrop: props => !props.isFileManagerOpen
};
const DroppableDummySection = props => {
  const {
    id,
    children,
    dropAtStartOfEmail,
    style,
    onSelect,
    renderToolbar = emptyFunction,
    connectDropTarget,
    isOver,
    isSelected
  } = props;
  const mouseIsOver = useSelector(getMouseOverSectionId) === id;
  const canDropOnSections = !useSelector(getIsSingleColumnFullWidth);
  const mouseDownRef = useRef(false);
  const handleMouseDown = useCallback(() => {
    mouseDownRef.current = true;
  }, []);
  const handleMouseUp = useCallback(() => {
    if (mouseDownRef.current && mouseIsOver && onSelect) {
      onSelect();
    }
    mouseDownRef.current = false;
  }, [mouseIsOver, onSelect]);
  const renderAffordances = () => mouseIsOver ? /*#__PURE__*/_jsx(AsyncSectionAffordances, {
    dragHandle: null,
    isDragging: false,
    isOver: true,
    isSelected: isSelected,
    draggable: false,
    children: renderToolbar()
  }) : null;
  const snapPlaceholderPosition = dropAtStartOfEmail ? DropPosition.AFTER : DropPosition.BEFORE;
  const sectionDom =
  /*#__PURE__*/
  /* @bend-expect trellis-tokenized */
  _jsxs("section", {
    className: "cos-section",
    "data-test-id": "dummy-section",
    id: id,
    style: Object.assign({}, style, {
      position: 'relative'
    }),
    children: [/*#__PURE__*/_jsx(SnapPlaceholder, {
      isVisible: !!isOver && canDropOnSections,
      position: snapPlaceholderPosition
    }), /*#__PURE__*/_jsx(View, {
      as: "section",
      "data-test-id": "dummy-section-inner",
      position: "relative",
      onMouseDown: handleMouseDown,
      onMouseUp: handleMouseUp,
      cursor: "pointer",
      children: /*#__PURE__*/_jsxs(MouseEventsHandler, {
        type: SECTION,
        id: id,
        children: [children, renderAffordances()]
      })
    })]
  });
  if (!canDropOnSections) {
    return sectionDom;
  }
  return connectDropTarget ? connectDropTarget(sectionDom) : sectionDom;
};
export default DropTarget([SECTION, ELEMENT, LAYOUT, NativeTypes.FILE], sectionTarget, monitor => {
  const itemType = monitor.getItemType();
  return {
    isOver: monitor.isOver({
      shallow: itemType !== SECTION && itemType !== LAYOUT
    })
  };
})(DroppableDummySection);